import React from "react";
import PropTypes, { InferProps } from "prop-types";
import Img from "gatsby-image";

const PreviewCompatibleImage = ({
  imageInfo,
}: InferProps<typeof PreviewCompatibleImage.propTypes>): ReactElement => {
  const { alt = "", childImageSharp, image, style } = imageInfo;

  if (!!image && !!image.childImageSharp) {
    return (
      <Img style={style} fluid={image.childImageSharp.fluid} alt={alt} />
    );
  }

  if (!!childImageSharp) {
    return <Img style={style} fluid={childImageSharp.fluid} alt={alt} />;
  }

  if (!!image && typeof image === "string")
    return <img style={style} src={image} alt={alt} />;

  return null;
};

PreviewCompatibleImage.propTypes = {
  imageInfo: PropTypes.shape({
    alt: PropTypes.string,
    childImageSharp: PropTypes.object,
    image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    style: PropTypes.object
  }).isRequired
};

export default PreviewCompatibleImage;
